
import { Component, MixedVue } from "@/vue";
import { getToday } from "../../lib/util";

@Component({
  name: "DowntimeNotice",
})
export default class DowntimeNotice extends MixedVue {
  upcomingDowntime: [Date, Date] = [new Date("2021-11-25"), new Date("2021-12-02")];

  get showNotice() {
    if (!this.upcomingDowntime) return false;
    const lastDay = this.upcomingDowntime[1];
    const today = getToday();
    return today <= lastDay;
  }

  get datePeriod() {
    if (!this.upcomingDowntime) return null;
    const [firstDay, lastDay] = this.upcomingDowntime;
    const sameYear = firstDay.getFullYear() == lastDay.getFullYear();
    const sameMonth = firstDay.getMonth() == lastDay.getMonth() && sameYear;
    const sameDay = firstDay.getDate() == lastDay.getDate() && sameMonth;
    const firstDayStr = firstDay.toLocaleDateString(this.$language.current, {
      year: !sameYear ? "numeric" : undefined,
      month: !sameMonth ? "long" : undefined,
      day: "numeric",
    });
    const lastDayStr = lastDay.toLocaleDateString(this.$language.current, {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
    if (sameDay) return lastDayStr;
    return `${firstDayStr} – ${lastDayStr}`;
  }

  get text() {
    return this.$gettext(
      "New satellite images are not available for the next 48 hours, as we are working on an improved version of our service. We apologize and thank you for your understanding. For more information, please write to us at support@ogor.ro."
    );
    // return this.$gettextInterpolate(
    //   this.$gettext("OGOR will be temporarily unavailable on %{period}."),
    //   { period: this.datePeriod }
    // );
  }
}
